import { styled, keyframes, css, useTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import { b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';

const Circle = styled.circle``;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const Svg = styled.svg`
  ${({
  intermediateMode,
  intermediateTimeMs
}) => intermediateMode && css`
      transition-property: transform;
      animation-name: ${rotate};
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      animation-duration: ${intermediateTimeMs}ms;
    `};
`;

function percentage(num, per) {
  return num / 100 * per;
}
function ProgressIndicatorWrapper({
  radius = 0,
  stroke = 0,
  value,
  disabled,
  intermediateMode,
  intermediateTimeMs,
  opacity,
  props = {}
}) {
  const theme = useTheme();
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - value / 100 * circumference;
  const strokeDasharray = intermediateMode ? `${circumference - percentage(circumference, 75)} ${circumference - percentage(circumference, 40)}` : `${circumference} ${circumference}`;
  const strokeOffset = intermediateMode ? 0 : strokeDashoffset;
  return /*#__PURE__*/createElement(Svg, _extends({
    intermediateMode: intermediateMode,
    intermediateTimeMs: intermediateTimeMs,
    style: {
      height: radius * 2,
      width: radius * 2,
      transform: `rotate(-90deg)`,
      opacity
    }
  }, props.svg), /*#__PURE__*/createElement(Circle, _extends({
    fill: "transparent",
    stroke: disabled ? theme.palette.grey[40] : theme.palette.success.main,
    strokeWidth: stroke,
    strokeDasharray: strokeDasharray,
    style: {
      strokeDashoffset: strokeOffset
    },
    className: "progress-indicator",
    r: normalizedRadius,
    cx: radius,
    cy: radius
  }, props.circle)));
}

export default ProgressIndicatorWrapper;
